import React from "react";

const NoneInput = () => {
  return <React.Fragment />;
};

export default NoneInput;
